import React from "react";
import MemberCandidateMenu from "../components/menu/admin/MemberCandidateMenu";

const CalonAnggota = () => {
  return <MemberCandidateMenu />;
};
export default CalonAnggota;
